export const WHATSAPP_NUMBER = "6289671894190";
export const DEFAULT_WHATSAPP_MESSAGE = "hallo kak?";

export function getWhatsAppUrl(message = DEFAULT_WHATSAPP_MESSAGE) {
  const params = new URLSearchParams({
    phone: WHATSAPP_NUMBER,
    text: message,
  });
  return `https://api.whatsapp.com/send?${params.toString()}`;
}
